import moment from 'moment'
import React, { useState } from 'react'
import styled from 'styled-components'

import Calendar from 'components/Calendar'
import Spinner from 'components/Spinner'

import useDeviceState from 'hooks/useDeviceState'
import { NoData, screenSize } from 'styles/shared'

import { color } from 'styles/colors'

type Props = {
  deviceId: string
}

const MidnightDeviceState = ({ deviceId }: Props) => {
  const [date, setDate] = useState(moment().startOf('days'))
  const { deviceState, areDeviceStateLoaded } = useDeviceState(deviceId, date.format('YYYY-MM-DD'))

  const onDateChange = (newDate) => {
    setDate(moment(newDate, 'YYYY-MM-DD'))
  }

  if (!areDeviceStateLoaded) {
    return <Spinner variant="page" />
  }

  return (
    <div>
      <S.DateAndTimePickerContainer>
        <S.Date>
          <span>{moment(date).format('MMMM D, YYYY')} </span>
          <Calendar
            date={date.format('YYYY-MM-DD')}
            variant="textOnly"
            onDateChangeCallback={onDateChange}
          />
        </S.Date>
      </S.DateAndTimePickerContainer>
      <div>
        {deviceState
          ? <pre>{JSON.stringify(deviceState, null, 2)}</pre>
          : <NoData><h1>Not Available</h1></NoData>
        }
      </div>

    </div>
  )
}

export default MidnightDeviceState

const S = {
  DateAndTimePickerContainer: styled.div`
    display: flex;
    align-items: center;
    padding: 20px 0px 10px 0px;

    @media ${screenSize.small} {
      flex-direction: column;
      align-items: start;
    }
  `,
  Date: styled.div`
    display: inline-block;
    white-space: nowrap;
    font-size: 20px;
    font-weight: bold;
    text-transform: uppercase;
    color: ${color('rthChartDate')};

    @media ${screenSize.small} {
      align-self: start;
      padding-bottom: 10px;
    }
  `
}
